/**
 * @generated SignedSource<<da52a55af52d8c8660402462cc2f9793>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_businessList_List_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewRootWithSmartCard_queryFragment">;
  readonly " $fragmentType": "src_businessList_List_queryFragment";
};
export type src_businessList_List_queryFragment$key = {
  readonly " $data"?: src_businessList_List_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_List_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_businessList_List_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_businessList_ListViewRootWithSmartCard_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "141e0658b8a403c4800a74e2c87fdb8d";

export default node;
